export class Primary {
  constructor() {
   this.name = 'Primary'
   this.content = {
    name: 'my modal',
    openOnLeave: false,
    timeOut: false,
    timeOutTime: null
   }
    this.view = this.viewHtml()
  }

  viewHtml() {
    return ''
  }

  classes() {
    return [
      //
    ]
  }

  styles() {
    return [
      {property:'BackgroundColor', styleProperty: 'background-image', value: 'linear-gradient(0deg, #ffffff,#ffffff)'},
      {property:'CustomWidth', styleProperty: 'width', value: '600px'},
    ]
  }

  containerClasses() {
    return [
      {property: 'VerticalPosition', value: 'POSITION_MIDDLE'},
      {property: 'HorizontalPosition', value: 'POSITION_CENTER'},
      {property: 'Rounded', value: 'ROUNDED_LG'},
      {property: 'Shadow', value: 'SHADOW_MD'},
    ]
  }

  containerStyles() {
    return [
      //
    ]
  }

  buildData() {
    return {
      name: this.name,
      view: this.view,
    }
  }

  editorProperties() {
    return {
      content: this.content,
      styles: {
        desktop: this.styles(),
        tablet: this.styles(),
        phone: this.styles()
      },
      classes: {
        desktop: this.classes(),
        tablet: this.classes(),
        phone: this.classes()
      },
      containerStyles: {
        desktop: this.containerStyles(),
        tablet: this.containerStyles(),
        phone: this.containerStyles()
      },
      containerClasses: {
        desktop: this.containerClasses(),
        tablet: this.containerClasses(),
        phone: this.containerClasses()
      },
    }
  }
}
